'use client';
import { useTranslation } from 'react-i18next';
import ViewpointItem from './viewpoint-item';
import { JContainer } from '@/components/ui/layout';

function Viewpoint() {
    const { t } = useTranslation('viewpoint');

    const viewpoints: {
        id: string;
        href: string;
        title: string;
        content: { isLink: boolean; text: string; href: string }[];
        overview: string;
        imageUrl: string;
        imageDesc: string;
        topic: string;
    }[] = t('viewpoints', {
        returnObjects: true,
    }) as {
        id: string;
        href: string;
        title: string;
        content: { isLink: boolean; text: string; href: string }[];
        overview: string;
        imageUrl: string;
        imageDesc: string;
        topic: string;
    }[];

    return (
        <div className="tablet:mt-[240px] mb-[-1px] mt-[120px] flex w-full flex-col items-center justify-center">
            <JContainer
                size="lg"
                padding="md"
                className="tablet:gap-[240px] flex flex-col gap-[120px] "
            >
                <h2 className="hidden">{t('challengesAndProspects')}</h2>
                {viewpoints.map((viewpoint, index) => (
                    <ViewpointItem
                        key={viewpoint.id}
                        readMoreButtonText={t('readMoreButton')}
                        {...viewpoint}
                        reverse={index % 2 != 0}
                    />
                ))}
            </JContainer>
        </div>
    );
}

export default Viewpoint;
